import { ActionIcon, Tooltip } from '@mantine/core';
import { useReportDownload } from 'hooks/api/useReports';
import { useTranslation } from 'react-i18next';
import { BsDownload } from 'react-icons/bs';

interface Props {
  reportId: string;
}

export const DownloadReportActionIcon = ({ reportId }: Props) => {
  const { mutate: downloadReport, isPending } = useReportDownload();
  const { t } = useTranslation();

  return (
    <Tooltip label={t('download_label')}>
      <ActionIcon onClick={() => downloadReport(reportId)} variant={'outline'} size={'sm'} loading={isPending}>
        <BsDownload color={'var(--mantine-color-blue-5)'} />
      </ActionIcon>
    </Tooltip>
  );
};
